import {joiResolver} from '@hookform/resolvers/joi';
import {AxiosError} from 'axios';
import {useForm, UseFormReturn} from 'react-hook-form';
import {TFunction} from 'react-i18next';
import {stringToPayloadFormat} from 'web-library';
import {GenericErrorResponse} from '../../../api';
import schemaUnlockAccountForm from '../schema/schemaUnlockAccountForm';
import {UseCustomMutationReturn} from '../../../api-refactored/utils/useCustomMutation';
import {
  PostUnlockAccountFormData,
  usePostUnlockAccount,
} from '../../../api-refactored/auth/usePostUnlockAccount';

export interface UsePostUnlockAccountFormInterface {
  form: UseFormReturn<PostUnlockAccountFormData>;
  postUnlockAccount: (formData: PostUnlockAccountFormData) => void;
  postUnlockAccountMutation: UseCustomMutationReturn<
      any,
      AxiosError<GenericErrorResponse>,
      PostUnlockAccountFormData,
      unknown
  >;
}

export const usePostUnlockAccountForm = (
    t: TFunction,
    onSuccessCallback: () => void,
    onFailureCallback: (err: AxiosError<GenericErrorResponse>) => void
): UsePostUnlockAccountFormInterface => {
  const form = useForm<PostUnlockAccountFormData>({
    mode: 'onSubmit',
    resolver: joiResolver(schemaUnlockAccountForm(t)),
  });

  const postUnlockAccountMutation = usePostUnlockAccount({
    onSuccess: () => {
      onSuccessCallback();
    },
    onError: (err) => {
      onFailureCallback(err);
    },
  });

  const postUnlockAccount = (formData: PostUnlockAccountFormData) => {
    postUnlockAccountMutation.mutate({
      ...formData,
      dateOfBirth: formData.dateOfBirth,
    });
  };

  return {
    form,
    postUnlockAccount,
    postUnlockAccountMutation,
  };
};
